import { default as Accessibility } from "./IcAccessibility";
import { default as Animation } from "./IcAnimation";
import { default as Apps } from "./IcApps";
import { default as Area } from "./IcArea";
import { default as AreasChart } from "./IcAreasChart";
import { default as ArrowDown } from "./IcArrowDown";
import { default as ArrowLeft } from "./IcArrowLeft";
import { default as ArrowRight } from "./IcArrowRight";
import { default as ArrowUp } from "./IcArrowUp";
import { default as ArrowUpRight } from "./IcArrowUpRight";
import { default as Balance } from "./IcBalance";
import { default as Bar } from "./IcBar";
import { default as Bold } from "./IcBold";
import { default as Bookmark } from "./IcBookmark";
import { default as Building } from "./IcBuilding";
import { default as Calendar } from "./IcCalendar";
import { default as Cancel } from "./IcCancel";
import { default as Cart } from "./IcCart";
import { default as Categories } from "./IcCategories";
import { default as ChartBar } from "./IcChartBar";
import { default as ChartColumn } from "./IcChartColumn";
import { default as ChartPivotTable } from "./IcChartPivotTable";
import { default as CheckHalf } from "./IcCheckHalf";
import { default as Checkmark } from "./IcCheckmark";
import { default as CheckmarkCircle } from "./IcCheckmarkCircle";
import { default as ChevronDoubleLeft } from "./IcChevronDoubleLeft";
import { default as ChevronDoubleRight } from "./IcChevronDoubleRight";
import { default as ChevronDown } from "./IcChevronDown";
import { default as ChevronLeft } from "./IcChevronLeft";
import { default as ChevronLineLeft } from "./IcChevronLineLeft";
import { default as ChevronLineRight } from "./IcChevronLineRight";
import { default as ChevronRight } from "./IcChevronRight";
import { default as ChevronSmallDown } from "./IcChevronSmallDown";
import { default as ChevronSmallLeft } from "./IcChevronSmallLeft";
import { default as ChevronSmallRight } from "./IcChevronSmallRight";
import { default as ChevronSmallUp } from "./IcChevronSmallUp";
import { default as ChevronUp } from "./IcChevronUp";
import { default as Circle } from "./IcCircle";
import { default as Clear } from "./IcClear";
import { default as Close } from "./IcClose";
import { default as Color } from "./IcColor";
import { default as Column } from "./IcColumn";
import { default as ColumnLineChart } from "./IcColumnLineChart";
import { default as Copy } from "./IcCopy";
import { default as Dashboard } from "./IcDashboard";
import { default as Description } from "./IcDescription";
import { default as Desktop } from "./IcDesktop";
import { default as Dot } from "./IcDot";
import { default as Dots } from "./IcDots";
import { default as Doublearrow } from "./IcDoublearrow";
import { default as Download } from "./IcDownload";
import { default as DragIndicator } from "./IcDragIndicator";
import { default as Dragndrop } from "./IcDragndrop";
import { default as DualAxisChart } from "./IcDualAxisChart";
import { default as Duplicate } from "./IcDuplicate";
import { default as Embed } from "./IcEmbed";
import { default as Envelope } from "./IcEnvelope";
import { default as Expand } from "./IcExpand";
import { default as Eyedropper } from "./IcEyedropper";
import { default as Facebook } from "./IcFacebook";
import { default as File } from "./IcFile";
import { default as FileCode } from "./IcFileCode";
import { default as Filter } from "./IcFilter";
import { default as Folder } from "./IcFolder";
import { default as FontSize } from "./IcFontSize";
import { default as Formatting } from "./IcFormatting";
import { default as Forward } from "./IcForward";
import { default as FreeCanvas } from "./IcFreeCanvas";
import { default as Hide } from "./IcHide";
import { default as Home } from "./IcHome";
import { default as Image } from "./IcImage";
import { default as Indeterminate } from "./IcIndeterminate";
import { default as InfoCircle } from "./IcInfoCircle";
import { default as InfoCircleFilled } from "./IcInfoCircleFilled";
import { default as Instagram } from "./IcInstagram";
import { default as Italic } from "./IcItalic";
import { default as Joint } from "./IcJoint";
import { default as Laptop } from "./IcLaptop";
import { default as LayoutOptions } from "./IcLayoutOptions";
import { default as LayoutSingle } from "./IcLayoutSingle";
import { default as LayoutTab } from "./IcLayoutTab";
import { default as LayoutTall } from "./IcLayoutTall";
import { default as LayoutVertical } from "./IcLayoutVertical";
import { default as LegacyLinkExternal } from "./IcLegacyLinkExternal";
import { default as Legal } from "./IcLegal";
import { default as LineChart } from "./IcLineChart";
import { default as Link } from "./IcLink";
import { default as LinkedIn } from "./IcLinkedIn";
import { default as ListBullet } from "./IcListBullet";
import { default as ListNumber } from "./IcListNumber";
import { default as Login } from "./IcLogin";
import { default as Logout } from "./IcLogout";
import { default as Map } from "./IcMap";
import { default as MapChart } from "./IcMapChart";
import { default as MapMarker } from "./IcMapMarker";
import { default as MapRegions } from "./IcMapRegions";
import { default as MapSymbols } from "./IcMapSymbols";
import { default as MapThemes } from "./IcMapThemes";
import { default as Menu } from "./IcMenu";
import { default as Message } from "./IcMessage";
import { default as Minus } from "./IcMinus";
import { default as Mobile } from "./IcMobile";
import { default as More } from "./IcMore";
import { default as MoreFilled } from "./IcMoreFilled";
import { default as MultilineChart } from "./IcMultilineChart";
import { default as Next } from "./IcNext";
import { default as Normalize } from "./IcNormalize";
import { default as Numerical } from "./IcNumerical";
import { default as Organisations } from "./IcOrganisations";
import { default as Pause } from "./IcPause";
import { default as Pen } from "./IcPen";
import { default as Pie } from "./IcPie";
import { default as PieChart } from "./IcPieChart";
import { default as Pin } from "./IcPin";
import { default as Play } from "./IcPlay";
import { default as Plus } from "./IcPlus";
import { default as PointInTime } from "./IcPointInTime";
import { default as Previous } from "./IcPrevious";
import { default as Printer } from "./IcPrinter";
import { default as Refresh } from "./IcRefresh";
import { default as Repeat } from "./IcRepeat";
import { default as Reset } from "./IcReset";
import { default as Rewind } from "./IcRewind";
import { default as ScatterplotChart } from "./IcScatterplotChart";
import { default as Search } from "./IcSearch";
import { default as Segments } from "./IcSegments";
import { default as Settings } from "./IcSettings";
import { default as Share } from "./IcShare";
import { default as SharedDimension } from "./IcSharedDimension";
import { default as Show } from "./IcShow";
import { default as Size } from "./IcSize";
import { default as Sort } from "./IcSort";
import { default as SortAscending } from "./IcSortAscending";
import { default as SortDescending } from "./IcSortDescending";
import { default as Star } from "./IcStar";
import { default as StarFilled } from "./IcStarFilled";
import { default as Sum } from "./IcSum";
import { default as Swatch } from "./IcSwatch";
import { default as TableChart } from "./IcTableChart";
import { default as TableColumnCategorical } from "./IcTableColumnCategorical";
import { default as TableColumnCategoricalHidden } from "./IcTableColumnCategoricalHidden";
import { default as TableColumnLocations } from "./IcTableColumnLocations";
import { default as TableColumnLocationsHidden } from "./IcTableColumnLocationsHidden";
import { default as TableColumnNumerical } from "./IcTableColumnNumerical";
import { default as TableColumnNumericalHidden } from "./IcTableColumnNumericalHidden";
import { default as TableColumnTime } from "./IcTableColumnTime";
import { default as TableColumnTimeHidden } from "./IcTableColumnTimeHidden";
import { default as Tablet } from "./IcTablet";
import { default as Target } from "./IcTarget";
import { default as Text } from "./IcText";
import { default as Trash } from "./IcTrash";
import { default as Twitter } from "./IcTwitter";
import { default as Underlined } from "./IcUnderlined";
import { default as Unfold } from "./IcUnfold";
import { default as Unlink } from "./IcUnlink";
import { default as Unpin } from "./IcUnpin";
import { default as Unpublish } from "./IcUnpublish";
import { default as Upload } from "./IcUpload";
import { default as WarningCircle } from "./IcWarningCircle";
import { default as WarningCircleFilled } from "./IcWarningCircleFilled";
import { default as WiFi } from "./IcWiFi";
import { default as XAxis } from "./IcXAxis";
import { default as YAxis } from "./IcYAxis";
import { default as Youtube } from "./IcYoutube";
import { default as ZoomIn } from "./IcZoomIn";

export const Icons = {
  apps: Apps,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUp: ArrowUp,
  arrowUpRight: ArrowUpRight,
  balance: Balance,
  bookmark: Bookmark,
  building: Building,
  calendar: Calendar,
  cancel: Cancel,
  chartBar: ChartBar,
  chartColumn: ChartColumn,
  checkmark: Checkmark,
  checkmarkCircle: CheckmarkCircle,
  chevronDoubleLeft: ChevronDoubleLeft,
  chevronDoubleRight: ChevronDoubleRight,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronLineLeft: ChevronLineLeft,
  chevronLineRight: ChevronLineRight,
  chevronRight: ChevronRight,
  chevronSmallDown: ChevronSmallDown,
  chevronSmallLeft: ChevronSmallLeft,
  chevronSmallRight: ChevronSmallRight,
  chevronSmallUp: ChevronSmallUp,
  chevronUp: ChevronUp,
  circle: Circle,
  close: Close,
  description: Description,
  desktop: Desktop,
  dots: Dots,
  download: Download,
  dragIndicator: DragIndicator,
  duplicate: Duplicate,
  embed: Embed,
  envelope: Envelope,
  expand: Expand,
  eyedropper: Eyedropper,
  facebook: Facebook,
  file: File,
  fileCode: FileCode,
  filter: Filter,
  folder: Folder,
  home: Home,
  infoCircle: InfoCircle,
  infoCircleFilled: InfoCircleFilled,
  instagram: Instagram,
  laptop: Laptop,
  link: Link,
  linkedIn: LinkedIn,
  listBullet: ListBullet,
  listNumber: ListNumber,
  login: Login,
  logout: Logout,
  mapMarker: MapMarker,
  menu: Menu,
  message: Message,
  minus: Minus,
  mobile: Mobile,
  more: More,
  moreFilled: MoreFilled,
  pen: Pen,
  pin: Pin,
  plus: Plus,
  printer: Printer,
  repeat: Repeat,
  search: Search,
  share: Share,
  star: Star,
  starFilled: StarFilled,
  tablet: Tablet,
  trash: Trash,
  twitter: Twitter,
  unlink: Unlink,
  unpin: Unpin,
  upload: Upload,
  warningCircle: WarningCircle,
  warningCircleFilled: WarningCircleFilled,
  wiFi: WiFi,
  youtube: Youtube,
  accessibility: Accessibility,
  animation: Animation,
  area: Area,
  areasChart: AreasChart,
  bar: Bar,
  bold: Bold,
  cart: Cart,
  categories: Categories,
  chartPivotTable: ChartPivotTable,
  checkHalf: CheckHalf,
  clear: Clear,
  color: Color,
  columnLineChart: ColumnLineChart,
  column: Column,
  copy: Copy,
  dashboard: Dashboard,
  dot: Dot,
  doublearrow: Doublearrow,
  dragndrop: Dragndrop,
  dualAxisChart: DualAxisChart,
  fontSize: FontSize,
  formatting: Formatting,
  forward: Forward,
  freeCanvas: FreeCanvas,
  hide: Hide,
  image: Image,
  indeterminate: Indeterminate,
  italic: Italic,
  joint: Joint,
  layoutOptions: LayoutOptions,
  layoutSingle: LayoutSingle,
  layoutTab: LayoutTab,
  layoutTall: LayoutTall,
  layoutVertical: LayoutVertical,
  legacyLinkExternal: LegacyLinkExternal,
  legal: Legal,
  lineChart: LineChart,
  mapChart: MapChart,
  map: Map,
  mapRegions: MapRegions,
  mapSymbols: MapSymbols,
  mapThemes: MapThemes,
  multilineChart: MultilineChart,
  next: Next,
  normalize: Normalize,
  numerical: Numerical,
  organisations: Organisations,
  pause: Pause,
  pieChart: PieChart,
  pie: Pie,
  play: Play,
  pointInTime: PointInTime,
  previous: Previous,
  refresh: Refresh,
  reset: Reset,
  rewind: Rewind,
  scatterplotChart: ScatterplotChart,
  segments: Segments,
  settings: Settings,
  sharedDimension: SharedDimension,
  show: Show,
  size: Size,
  sort: Sort,
  sortAscending: SortAscending,
  sortDescending: SortDescending,
  sum: Sum,
  swatch: Swatch,
  tableChart: TableChart,
  tableColumnCategorical: TableColumnCategorical,
  tableColumnCategoricalHidden: TableColumnCategoricalHidden,
  tableColumnLocations: TableColumnLocations,
  tableColumnLocationsHidden: TableColumnLocationsHidden,
  tableColumnNumerical: TableColumnNumerical,
  tableColumnNumericalHidden: TableColumnNumericalHidden,
  tableColumnTime: TableColumnTime,
  tableColumnTimeHidden: TableColumnTimeHidden,
  target: Target,
  text: Text,
  underlined: Underlined,
  unfold: Unfold,
  unpublish: Unpublish,
  xAxis: XAxis,
  yAxis: YAxis,
  zoomIn: ZoomIn,
};

export type IconName = keyof typeof Icons;
